import { FC } from 'react';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import { useTranslate } from 'hooks/useTranslate';
import { dateFormat } from 'constants/formats';
import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

import TableRow from 'modules/_shared/Table/components/TableRow';
import { RowCell } from 'modules/_shared/Table/types/RowCell';
import { Eligible } from 'modules/transactions/pages/TenderOfferDetails/types/Eligible';

type IncentiveOfferEligiblesTableRowProps = {
  rowNumber: number;
  eligible: Eligible;
};

const IncentiveOfferEligiblesTableRow: FC<
  IncentiveOfferEligiblesTableRowProps
> = ({ rowNumber, eligible }) => {
  const { t } = useTranslate();

  const cells = [
    {
      key: `index-${rowNumber}`,
      content: rowNumber,
    },
    {
      key: `name-${rowNumber}`,
      content: (
        <div className="tb-tnx-info w-150px text-ellipsis">
          <Link to={eligible.link}>
            <span className="title">{eligible.name}</span>
          </Link>
        </div>
      ),
    },
    {
      key: `totalUnits-${rowNumber}`,
      content: formatNumber(eligible.totalUnits),
      textPosition: 'right',
      hideOnMobile: true,
    },
    {
      key: `maximumSaleUnits-${rowNumber}`,
      content: formatNumber(eligible.maximumSaleUnits),
      textPosition: 'right',
    },
    {
      key: `offerAmount-${rowNumber}`,
      content: formatCurrencyDecimals(eligible.offerAmount),
      textPosition: 'right',
      hideOnMobile: true,
    },
    {
      key: `soldUnits-${rowNumber}`,
      content: formatNumber(eligible.soldUnits),
      textPosition: 'right',
    },
    {
      key: `soldAmount-${rowNumber}`,
      content: formatCurrencyDecimals(eligible.soldAmount),
      textPosition: 'right',
    },
    {
      key: `strikePrice-${rowNumber}`,
      content: formatCurrencyDecimals(eligible.strikePrice),
      textPosition: 'right',
    },
    {
      key: `netAmount-${rowNumber}`,
      content: formatCurrencyDecimals(eligible.netAmount),
      textPosition: 'right',
    },
    {
      key: `saleDate-${rowNumber}`,
      content: eligible.saleDate ? format(eligible.saleDate, dateFormat) : '-',
      textPosition: 'center',
    },
    {
      key: `status-${rowNumber}`,
      content: (
        <span className={`badge badge-check ${eligible.statusBadge}`}>
          {t(eligible.statusLabel)}
        </span>
      ),
      textPosition: 'center',
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default IncentiveOfferEligiblesTableRow;
